// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"f6919bc1","95":"112828a0","124":"25b62496","187":"063e74d9","245":"effc6b43","270":"07c851a2","415":"3b8c48c6","453":"24dd030b","591":"29be25f9","654":"5d839b45","750":"4eb56904","790":"e5d7b112","858":"47edacae","862":"1f756f58","932":"611158e1","947":"fce9565b"}[chunkId] + ".chunk.js";
};